import {tabs} from '../../../_mixins/tabs'
import {client_api_post_user_subscribe_author} from '../../../_mixins/client-api/user'

document.addEventListener('DOMContentLoaded', () => {
    tabs('.js_segment-tabs', 'segment-tabs__item_active')

    document.getElementById('js_btn-modal-subscribe-author').addEventListener('click', function () {
        const author = this.dataset.author
        const el_btn_modal = this

        if (g_params.user?.mail) {
            send_req(el_btn_modal, author, g_params.user.mail)
        } else {
            rb_modals.show('#js_modal-subscribe-author')

            document.getElementById('js_form-subscribe-author').addEventListener('submit', function (event) {
                event.preventDefault()

                const input_email = document.getElementById('js_email-subscribe-author')
                const email = input_email.value.trim()

                if (!email) {
                    input_email.focus()
                    return
                }

                if (this.disabled) return;

                this.disabled = true

                const btn_content = event.submitter?.innerHTML

                if (btn_content) {
                    event.submitter.innerHTML = '<i class="i-loading i-loading_xs i-loading_white"></i>'
                }

                send_req(el_btn_modal, author, email)
                    .then(() => {
                        document.getElementById('js_modal-subscribe-author').modal.close()
                        input_email.value = ''
                    })
                    .finally(() => {
                        if (btn_content) {
                            event.submitter.innerHTML = btn_content
                        }

                        this.disabled = false
                    })
            })
        }

        function send_req(el_btn_modal, author, email) {
            el_btn_modal.disabled = true

            const el_btn_modal_content = el_btn_modal.innerHTML

            el_btn_modal.innerHTML = '<i class="i-loading i-loading_xs i-loading_white"></i>'

            return client_api_post_user_subscribe_author({
                author,
                email
            })
                .then(data => {
                    notify.success(data.message || 'Подписка оформлена')

                    el_btn_modal.classList.add('rb-btn_light')
                    el_btn_modal.classList.remove('rb-btn_success')
                    el_btn_modal.innerHTML = 'Подписка оформлена'
                })
                .catch(err => {
                    handling_error(err)

                    el_btn_modal.innerHTML = el_btn_modal_content
                    el_btn_modal.disabled = false
                    
                    throw err
                })
        }
    })
})